import styled, { css } from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  width: 16px;
  background: ${props => props.theme.cores.cinza200};
  border-radius: 50%;
  margin-right: 0;

  > svg {
    width: calc(100% - 4px);
    height: calc(100% - 4px);
  }

  span {
    color: ${props => props.theme.cores.cinzaMenuSuperiorEscuro};
  }

  ${props => ( props.active || props.completed ) && css`
    background: ${props.theme.cores.azul};

    span {
      color: ${props.theme.cores.branco};
      opacity: 1;
    }
  `}

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    height: 32px;
    width: 32px;
    background: ${props => props.theme.cores.branco};
    box-sizing: border-box;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    margin-right: 9px;

    > svg {
      width: calc(100% - 12px);
      height: calc(100% - 12px);
    }

    ${props => ( props.active || props.completed ) && css`
      span {
        color: ${props.theme.cores.cinzaMenuSuperiorClaro};
        opacity: 1;
      }
    `}

    ${props => ( props.active ) && css`
      border: 1px solid ${props.theme.cores.azulEscuro};
    `}
    
    ${props => props.completed && css`
      background: ${props.theme.cores.azul};
    `}
  }
`

export { Container }
